import moment from 'moment';
import { Panel, PanelType } from 'office-ui-fabric-react';
import React, { useState } from 'react';


interface IProps {
    disabled: boolean;
    nomination: any;
}

const detailFields = [
    { key: "nominationId", label: "Nomination ID" },
    { key: "nominationNr", label: "Nomination NR" },
    { key: "nominationIt", label: "Nomination IT" },
    { key: "nominationSt", label: "Nomination ST" },
    { key: "customerName", label: "Customer Name" },
    { key: "customerPo", label: "Customer PO" },
    { key: "productName", label: "Product Name" },
    { key: "poundsPerGallon", label: "Pounds Per Gallon" },
    { key: "sloc", label: "Sloc" },
    { key: "activity", label: "Activity" },
    { key: "direction", label: "Direction" },
    { key: "promiseDate", label: "Promise Date", type: 'date'},
    { key: "requestedQty", label: "Requested Quantity" },
    { key: "minimumQty", label: "Minimum Quantity" },
    { key: "maximumQty", label: "Maximum Quantity" },
    { key: "loadingStation", label: "Loading Station" },
    { key: "created", label: "Created", type: 'date' },
    { key: "updated", label: "Updated", type: 'date' }
]

const renderRow = (value: string | number, type?: string) => {
    if (!['', null, undefined].includes(`${value}`)) {
        if (type === "date") {
            return moment(value).format('MM/DD/YYYY')
        }
        return value;
    }
    return "N/A"
}
const NominationDetailBtn = ({ disabled, nomination }: IProps) => {

    const [isOpen, setIsOpen] = useState(false);

    return (
        <>
            <button
                type="button"
                className="btn btn-light rounded-pill"
                disabled={disabled}
                onClick={() => setIsOpen(true)}
            >
                Nomination Details
            </button>
            <Panel
                isLightDismiss
                isOpen={isOpen}
                onDismiss={() => setIsOpen(false)}
                headerText="Nomination Details"
                closeButtonAriaLabel="Close"
                type={PanelType.medium}
                layerProps={{ eventBubblingEnabled: true }}
                styles={{
                    scrollableContent: { overflow: "visible" },
                    content: { overflow: "visible" },
                }}
            >
                <div style={{ height: 'calc(100vh - 50px)', paddingTop: 15, overflow: 'auto' }}>
                    {
                        detailFields.map(({ key, label, type }) => (
                            <div className="d-flex justify-content-between py-2 border-bottom">
                                <div> {label} </div>
                                <div className="font-weight-bold"> {renderRow(nomination?.[key], type)} </div>
                            </div>)
                        )
                    }
                </div>
            </Panel>
        </>
    )
}
export default NominationDetailBtn;
